<template lang="pug">
.fits-image
  div(v-for="fitsImage in frameStore.fitsImages", :key="fitsImage.id")
    v-tile-layer(:show="fitsImage.show", :animationLod="Store.config.tileLayer.animationLod", :lodBias="Store.config.tileLayer.lodBias")
      TextureProvider(:fitsImage="fitsImage")
</template>


<script lang="ts">
import Vue from 'vue'
import TextureProvider from "./TextureProvider";

export default Vue.extend({
  components: {
  TextureProvider,
  },
  props: {
  frameStore: { required: true },
  },
})
</script>